import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-[60vh] flex items-center justify-center p-6"
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-md text-center">
            <div className="w-14 h-14 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-4">
              <span className="text-red-400 text-2xl font-bold">!</span>
            </div>
            <h2 className="font-heading text-xl font-bold mb-2">Something went wrong</h2>
            <p className="text-sm text-gray-400 mb-5">
              The page hit an unexpected error. Your data is safe — try reloading or going back.
            </p>
            <div className="flex gap-2 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="bg-cyan-500 text-black hover:bg-cyan-400 font-bold h-10 px-5 rounded-md text-sm"
                data-testid="error-reload-btn"
              >
                Reload
              </button>
              <button
                onClick={this.handleReset}
                className="border border-white/10 text-gray-300 hover:bg-white/5 h-10 px-5 rounded-md text-sm"
                data-testid="error-dismiss-btn"
              >
                Dismiss
              </button>
            </div>
            {this.state.error?.message && (
              <p className="mt-4 text-[10px] text-gray-600 font-mono break-all">
                {this.state.error.message}
              </p>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
